import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { to: '/', label: 'Главная' },
    { to: '/services', label: 'Услуги' },
    { to: '/cases', label: 'Кейсы' },
    { to: '/about', label: 'О стилисте' },
    { to: '/cabinet/login', label: 'Вход для клиентов' }
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      backgroundColor: scrolled ? 'rgba(255, 255, 255, 0.98)' : 'transparent',
      backdropFilter: scrolled ? 'blur(10px)' : 'none',
      borderBottom: scrolled ? '1px solid var(--soft-gray)' : 'none',
      transition: 'all 400ms cubic-bezier(0.4, 0, 0.2, 1)'
    }}>
      <nav style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: scrolled ? 'var(--space-m) var(--space-xl)' : 'var(--space-l) var(--space-xl)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        transition: 'padding 400ms ease'
      }}>
        {/* Logo */}
        <Link to="/" style={{
          textDecoration: 'none',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <span style={{
            fontFamily: 'var(--font-display)',
            fontSize: scrolled ? '1.5rem' : '1.75rem',
            color: 'var(--black)',
            letterSpacing: '-0.02em',
            fontWeight: 300,
            transition: 'font-size 400ms ease'
          }}>
            Наталья Ромашова
          </span>
        </Link>

        {/* Desktop Navigation */}
        <div style={{
          display: 'none',
          gap: 'var(--space-xl)',
          alignItems: 'center'
        }}
        className="desktop-nav">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              style={{
                fontFamily: 'var(--font-body)',
                fontSize: '0.8125rem',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                color: isActive(link.to) ? 'var(--black)' : 'var(--mid-gray)',
                textDecoration: 'none',
                fontWeight: 400,
                position: 'relative',
                transition: 'color 300ms ease'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--black)'}
              onMouseLeave={(e) => e.target.style.color = isActive(link.to) ? 'var(--black)' : 'var(--mid-gray)'}
            >
              {link.label}
              {isActive(link.to) && (
                <span style={{
                  position: 'absolute',
                  bottom: '-8px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '4px',
                  height: '4px',
                  backgroundColor: 'var(--accent-gold)',
                  borderRadius: '50%'
                }} />
              )}
            </Link>
          ))}
          <Link to="/#contact">
            <button className="btn-primary" style={{ 
              fontSize: '0.75rem', 
              padding: scrolled ? '12px 28px' : '14px 32px',
              transition: 'all 400ms ease'
            }}>
              <span>Связаться</span>
            </button>
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          style={{
            display: 'block',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--black)',
            padding: 'var(--space-s)'
          }}
          className="mobile-menu-btn"
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div style={{
          display: 'block',
          backgroundColor: 'var(--white)',
          borderTop: '1px solid var(--soft-gray)',
          padding: 'var(--space-xl) var(--space-l)'
        }}
        className="mobile-menu">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setIsMenuOpen(false)}
              style={{
                display: 'block',
                fontFamily: 'var(--font-body)',
                fontSize: '0.8125rem',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                color: isActive(link.to) ? 'var(--black)' : 'var(--mid-gray)',
                textDecoration: 'none',
                fontWeight: 400,
                padding: 'var(--space-m) 0',
                borderBottom: '1px solid var(--soft-gray)'
              }}
            >
              {link.label}
            </Link>
          ))}
          <div style={{ marginTop: 'var(--space-l)' }}>
            <Link to="/#contact" onClick={() => setIsMenuOpen(false)}>
              <button className="btn-primary" style={{ width: '100%' }}>
                <span>Связаться</span>
              </button>
            </Link>
          </div>
        </div>
      )}

      <style>{`
        @media (min-width: 769px) {
          .desktop-nav {
            display: flex !important;
          }
          .mobile-menu-btn {
            display: none !important;
          }
          .mobile-menu {
            display: none !important;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;
